import React from 'react';
import PropTypes from 'prop-types';

function ShowSidebarButton({ onClick, className = 'btn btn-setlist-tertiary btn-sm me-3' }) {
  return (
    <button type="button" className={className} onClick={onClick} aria-label="Show sidebar">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" style={{ transform: 'rotate(180deg)' }}>
        <path
          d="M13.3332 11.3333H2.6665M2.6665 11.3333L5.33317 14M2.6665 11.3333L5.33317 8.66667M13.3332 4.66667H5.99984M5.99984 4.66667L8.6665 7.33333M5.99984 4.66667L8.6665 2"
          stroke="#A4A7AE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

ShowSidebarButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default ShowSidebarButton;
